module.exports = __webpack_public_path__ + "static/media/YM11_2.18194dd2.jpg";